import React from "react";
import { FeatureArticleRichText } from "web/react/components/feature-article/feature-article-rich-text";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import * as styles from "./feature-article-summary.css";

interface FeatureArticleSummaryProps {
    title: string;
    body: string;
}

export function FeatureArticleSummary({
    title,
    body,
}: FeatureArticleSummaryProps): React.ReactElement {
    return (
        <VStack spacing="md">
            <div className={styles.divider} />
            <Text textStyle="caption-s" color="secondary" upperCase>
                {title}
            </Text>
            <FeatureArticleRichText>{body}</FeatureArticleRichText>
            <div className={styles.divider} />
        </VStack>
    );
}
